import { z } from 'zod'

import { BusinessDomainStatus, BusinessEmailStatus } from 'apps/email/emailConstants'

export const DomainSchema = z.object({
  domain: z.string().optional(),
  id: z.number().optional(),
  status: z.enum(BusinessDomainStatus).optional(),
  records: z
    .array(
      z.object({
        data: z.string(),
        host: z.string(),
        purpose: z.string(),
        id: z.number(),
        status: z.enum(BusinessDomainStatus),
      }),
    )
    .optional(),
})

export const BusinessEmailSchema = z.object({
  id: z.number().nullable(),
  status: z.enum(BusinessEmailStatus),
  email: z.string().nullable(),
  sender_name: z.string().nullable(),
  reply_to: z.string().nullable(),
  is_default: z.boolean(),
  domain: DomainSchema,
})

export type BusinessEmail = z.infer<typeof BusinessEmailSchema>
